module.exports = __webpack_public_path__ + "review-gethead.mp4";